<h1 mat-dialog-title>Join This Game?</h1>
<div mat-dialog-content>
<table class="w-100 std-mb">
    <tbody>
        <tr>
            <td><strong>Venue</strong></td>
            <td><span>{{ data.game.venue }}</span></td>
        </tr>
        <tr>
            <td><strong>Game Type</strong></td>
            <td><span>{{ data.game.title == "trivia" ? "Pub Quiz" : data.game.title == "slam" ? "Survey Slam" : data.game.title == "bingo" ? "Music Bingo" : data.game.title }}</span></td>
        </tr>
        <tr>
            <td><strong>Time</strong></td>
            <td><span>{{ data.game.date | date: 'shortTime' }}</span></td>
        </tr>
        <tr>
            <td><strong>Host</strong></td>
            <td><span>{{ data.game.host }}</span></td>
        </tr>
    </tbody>
</table>
<p *ngIf="err" class="center-text error-message">{{err}}</p>
</div>
<div mat-dialog-actions align="center">
    <button mat-button mat-dialog-close >Cancel</button>
    <button mat-button cdkFocusInitial class="sm-ml" (click)="joinGame()">{{ joiningAsSpectator ? 'Joining...': 'Join' }}</button>
</div>